<template>
    <div id="navigation">
        <v-app-bar app color="#13323C" dark>
            <v-app-bar-nav-icon
                @click.stop="nav_drawer = !nav_drawer"
            ></v-app-bar-nav-icon>
            <v-toolbar-title>
                Schedules
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon v-on:click="toggle_dark_mode">
                <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
        </v-app-bar>

        <v-navigation-drawer app v-model="nav_drawer" absolute bottom temporary>
            <v-list shaped dense nav>
                <v-subheader>SCHEDULES</v-subheader>
                <v-list-item-group v-model="nav_list_model">
                    <router-link to="/">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon>mdi-home-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Home
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link
                        v-for="(schedule, index) in schedules"
                        :key="index"
                        :to="schedule.path"
                    >
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon v-text="schedule.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title
                                    v-text="schedule.name"
                                ></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    name: "AppNavigation",
    data: () => ({
        nav_drawer: false,
        nav_group: null,
        nav_list_model: 1
    }),
    props: ["schedules"],
    watch: {
        nav_group() {
            this.nav_drawer = false;
        }
    },
    methods: {
        toggle_dark_mode: function() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        }
    },
    mounted() {
        const theme = localStorage.getItem("dark_theme");
        if (theme) {
            if (theme == "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if (
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        }
        console.log(this.schedules);
    }
};
</script>

<style>
a:link {
    color: #ffffff;
    text-decoration: none;
}
</style>
